import { useState } from 'react'
import { __ } from '@wordpress/i18n'
import ModalContainer from '../Global/ModalContainer';
import Button from './Button';
import Source from './Source';
import CustomizerSourcesModal from '../Modals/CustomizerSourcesModal';

const FeedSources = ( props ) => {

    const activeSources = props.sources.sourcesList.filter( source =>  props?.value.includes( source.open_id ) );

    const [ sourcesModalActive, setSourcesModalActive ] = useState( false );

    const removeSource = ( sourceId ) => {
        props?.value.splice( props?.value.indexOf(sourceId), 1 );
        props.onChange( props.value );
    }

    return(
        <>
            {
                activeSources.map( ( source, sourceInd ) => {
                    const sourceInfo = source?.info !== '' && source?.info !== null && source?.info !== undefined ? JSON.parse(source?.info) : null;
                    return (
                        <Source
                            customClass='sb-source-control-item'
                            key={ sourceInd }
                            checkbox={ false }
                            name={source.display_name }
                            openId={source.open_id}
                            avatar={sourceInfo?.local_avatar_url || sourceInfo?.avatar_url}
                            removeIcon={ true }
                            onRemoveClick={ () => {
                                removeSource( source.open_id )
                            }}
                        />
                    )
                } )
            }
            <Button
                customClass='sb-sources-chooser-btn'
                icon='plus'
                size='small'
                full-width={ true }
                type='secondary'
                onClick={ () => {
                    setSourcesModalActive( true )
                }}
                text={ __( 'Add another Source', 'sb-customizer' ) }
            />
            {
                sourcesModalActive &&
                <ModalContainer
                    size={'medium'}
                    closebutton={true}
                    onClose={ () => {
                        setSourcesModalActive( false )
                    } }
                >
                    <CustomizerSourcesModal
                        sources={ props.sources }
                        selectedSources={ props?.value }
                        onCancel={ () => {
                            setSourcesModalActive( false )
                        } }
                        onUpdateSources={ ( element ) => {
                            props.onChange( element )
                            setSourcesModalActive( false )
                        } }
                    />
                </ModalContainer>
            }
        </>
    )
}
export default FeedSources;